$('.banner-slider .slides').slick({
	dots: false,
	fade: true,
	cssEase: 'linear',
	arrows: true,
	prevArrow: '<button type="button" class="slider-previous slick-prev"><span class="icon icon-arrow-left3"></span></button>',
	nextArrow: '<button type="button" class="slider-next slick-next"><span class="icon icon-arrow-right3"></span></button>',
	infinite: true,
	slide: '.slide',
	speed: 400,
	slidesToScroll: 1,
	autoplay: true,
	autoplaySpeed: 6000
});